// src/Zustand/AuthStore.js
import { create } from "zustand";
const useAuthStore = create((set) => ({
  isLoggedIn: false,
  userData: null,
  reporting_manager_employees: [],
  reporting_manager_interns: [],
  access : "User",
  login: (data) =>
    set({
      isLoggedIn: true,
      userData: data,
      reporting_manager_employees: data?.reporting_manager_employees ?? [],
      reporting_manager_interns: data?.reporting_manager_interns ?? [],
    }),
  updateOrganizationInUserData: (organizationId, updates) =>
    set((state) => {
      if (!state.userData) return state;

      const targetId = Number(organizationId);
      const patchOrg = (org) =>
        org && Number(org.organization_id) === targetId
          ? { ...org, ...updates }
          : org;

      const currentOrg = state.userData.organization;
      const updatedOrganization =
        currentOrg && !Array.isArray(currentOrg)
          ? patchOrg(currentOrg)
          : currentOrg;

      const updatedOrganizations = Array.isArray(state.userData.organizations)
        ? state.userData.organizations.map(patchOrg)
        : state.userData.organizations;

      return {
        userData: {
          ...state.userData,
          organization: updatedOrganization,
          ...(Array.isArray(updatedOrganizations)
            ? { organizations: updatedOrganizations }
            : {}),
        },
      };
    }),
  logout: () => {
    localStorage.removeItem("token");
    return set({
      isLoggedIn: false,
      userData: null,
      access: "User",
      reporting_manager_employees: [],
      reporting_manager_interns: [],
    });
  },
  setAccess: (access = "User") => set({ access: access})
}));
export default useAuthStore;
